/**
 * Composable pour les fonctions de formatage de dates
 * Centralise la logique de formatage répétée dans plusieurs composants
 */

export function useDateFormatter() {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    })
  }

  const formatTime = (dateString) => {
    return new Date(dateString).toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  const formatDateTime = (dateString) => {
    return new Date(dateString).toLocaleString('fr-FR')
  }

  const formatDateForAPI = (dateObj) => {
    if (!dateObj) return ''
    const y = dateObj.getFullYear()
    const m = String(dateObj.getMonth() + 1).padStart(2, '0')
    const d = String(dateObj.getDate()).padStart(2, '0')
    const h = String(dateObj.getHours()).padStart(2, '0')
    const min = String(dateObj.getMinutes()).padStart(2, '0')
    return `${y}-${m}-${d} ${h}:${min}:00`
  }

  const formatDateString = (year, month, day) => {
    return `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`
  }

  return {
    formatDate,
    formatTime,
    formatDateTime,
    formatDateForAPI,
    formatDateString
  }
}
